import { Timestamp } from "firebase/firestore";
import { Blog } from "../core/models/Blog";
import { CommentModel } from "../core/models/Comment";

const fakeBlog: Blog = {
    userID: "randomid",
    user: {
        email: "",
        creationDate: (new Date()).getTime(),
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        id: "",
        imageUrl: "",
        username: "",
    },
    commentsCounter: 0,
    createdAt: Timestamp.now(),
    description: "In ullamco cupidatat qui labore dolor aute cillum amet dolor velit exercitation commodo non culpa. Occaecat ad elit anim deserunt labore aute occaecat eiusmod magna culpa pariatur. Minim dolor aute minim sunt veniam ipsum cupidatat commodo labore. Anim adipisicing laborum nulla proident elit quis esse laboris nisi velit. Eiusmod tempor nostrud anim mollit id non sunt magna sint sunt. Dolor reprehenderit adipisicing adipisicing est duis minim voluptate quis commodo elit excepteur exercitation exercitation exercitation. Laborum aute officia sit mollit id.",
    id: "some-sort-of-slug",
    title: "#1: title",
    dislikeCounter: 0,
    likeCounter: 0,
    categories: [],
    images: [],
    markdown: `# Getting Started with Create React App
    This project was bootstrapped with [Create React App](https://github.com/facebook/create-react-app).
    
    ## Available Scripts
    
    In the project directory, you can run:
    
    ### "npm start"
    
    Runs the app in the development mode.\
    Open [http://localhost:3000](http://localhost:3000) to view it in the browser.
    
    The page will reload if you make edits.\
    You will also see any lint errors in the console.
    
    ### "npm test"
    
    Launches the test runner in the interactive watch mode.\
    See the section about [running tests](https://facebook.github.io/create-react-app/docs/running-tests) for more information.
    
    ### "npm run build"
    
    Builds the app for production to the "build" folder.\
    It correctly bundles React in production mode and optimizes the build for the best performance.
    
    The build is minified and the filenames include the hashes.\
    Your app is ready to be deployed!
    
    See the section about [deployment](https://facebook.github.io/create-react-app/docs/deployment) for more information.
    
    ### "npm run eject"
    
    **Note: this is a one-way operation. Once you "eject", you can’t go back!**
    
    If you aren’t satisfied with the build tool and configuration choices, you can "eject" at any time. This command will remove the single build dependency from your project.
    
    Instead, it will copy all the configuration files and the transitive dependencies (webpack, Babel, ESLint, etc) right into your project so you have full control over them. All of the commands except "eject" will still work, but they will point to the copied scripts so you can tweak them. At this point you’re on your own.
    
    You don’t have to ever use "eject". The curated feature set is suitable for small and middle deployments, and you shouldn’t feel obligated to use this feature. However we understand that this tool wouldn’t be useful if you couldn’t customize it when you are ready for it.
    
    ## Learn More
    
    You can learn more in the [Create React App documentation](https://facebook.github.io/create-react-app/docs/getting-started).
    
    To learn React, check out the [React documentation](https://reactjs.org/).
    ## This is a test
    - [ ] potato
    `
}

const fakeComments: CommentModel[] = [
    {
        id: "0",
        blogId: "some-sort-of-slug",
        text: "Fugiat quis fugiat eiusmod aute deserunt consectetur quis eiusmod deserunt nisi tempor sit ullamco do.",
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        userID: "qsdc-qsd-cqsdc-qsdcsd-cqsdcqs-",
        username: "Potato",
        userphoto: "https://api.dicebear.com/7.x/pixel-art/svg?seed=Potato",
        blogTitle: "a blog title",
    },
    {
        id: "1",
        blogId: "some-sort-of-slug",
        text: "Fugiat quis fugiat eiusmod aute deserunt consectetur quis eiusmod deserunt nisi tempor sit ullamco do.",
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        userID: "qsdc-qsd-cqsdc-qsdcsd-cqsdcqs-",
        username: "Potato",
        userphoto: "https://api.dicebear.com/7.x/pixel-art/svg?seed=Potato",
        blogTitle: "a blog title",
    },
    {
        id: "2",
        blogId: "some-sort-of-slug",
        text: "Fugiat quis fugiat eiusmod aute deserunt consectetur quis eiusmod deserunt nisi tempor sit ullamco do.",
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        userID: "qsdc-qsd-cqsdc-qsdcsd-cqsdcqs-",
        username: "Potato",
        userphoto: "https://api.dicebear.com/7.x/pixel-art/svg?seed=Potato",
        blogTitle: "a blog title",
    },
    {
        id: "3",
        blogId: "some-sort-of-slug",
        text: "Fugiat quis fugiat eiusmod aute deserunt consectetur quis eiusmod deserunt nisi tempor sit ullamco do.",
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        userID: "qsdc-qsd-cqsdc-qsdcsd-cqsdcqs-",
        username: "Potato",
        userphoto: "https://api.dicebear.com/7.x/pixel-art/svg?seed=Potato",
        blogTitle: "a blog title",
    },
];

export { fakeBlog, fakeComments };
